// extracted by mini-css-extract-plugin
export var background = "styles-module--background--77ed3";
export var backgroundCTA = "styles-module--backgroundCTA--fc27a";
export var blockquote = "styles-module--blockquote--e840c";
export var defaultCard = "styles-module--defaultCard--ee04d";
export var fiveCard = "styles-module--fiveCard--e9df5";
export var imageWrapper = "styles-module--imageWrapper--0d8ff";
export var qlikTabSlider = "styles-module--qlikTabSlider--39d1c";
export var threeCard = "styles-module--threeCard--363e6";